const industries = [
  { id: 1, key: 'consumer_products', label: 'Consumer Products' },
  { id: 2, key: 'education', label: 'Education' },
  { id: 3, key: 'energy', label: 'Energy' },
  { id: 4, key: 'fashion', label: 'Fashion' },
  { id: 5, key: 'finance', label: 'Finance' },
  { id: 6, key: 'food', label: 'Food' },
  { id: 7, key: 'entertainment', label: 'Entertainment' },
  { id: 8, key: 'health_beauty', label: 'Health & Beauty' },
  { id: 9, key: 'healthcare', label: 'Healthcare' },
  { id: 10, key: 'other', label: 'Other' },
  { id: 11, key: 'real_estate', label: 'Real Estate' },
  { id: 12, key: 'retail', label: 'Retail' },
  { id: 13, key: 'services', label: 'Services' },
  { id: 14, key: 'sports', label: 'Sports' },
  { id: 15, key: 'technology', label: 'Technology' },
  { id: 16, key: 'transportation', label: 'Transportation' },
  { id: 17, key: 'travel', label: 'Travel' },
]
export default industries
